export default __webpack_public_path__ + "static/media/flag-montenegro.66747f6b.svg";